
import AboutMe from '~/components/AboutMe/index.vue'
import {
  buildPageHead,
  buildAnalyticsMeta,
  buildHeadScripts,
} from '@/helpers/pageSeo'

export default {
  components: { AboutMe },
  middleware: ['returnUrl'],
  head() {
    const pageTitle = `${this.$custom$t('nav.about')} | ${this.$store.state.settings.title}`
    const { title, meta, link } = buildPageHead(this, {
      title: pageTitle,
      description: this.$custom$t('seo.pages.about.description'),
    })
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title,
      meta: [...meta, ...buildAnalyticsMeta(this)],
      link,
      script: buildHeadScripts(this),
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
}
